export enum ProjectType {
  Metro,
  Barrage,
  VoiesFerres,
  Route,
  Batiment,
  Nucleaire,
  Other,
}
